import { render, staticRenderFns } from "./RecurringRemarkSideMenu.vue?vue&type=template&id=368596d8"
import script from "./RecurringRemarkSideMenu.vue?vue&type=script&lang=js"
export * from "./RecurringRemarkSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('368596d8')) {
      api.createRecord('368596d8', component.options)
    } else {
      api.reload('368596d8', component.options)
    }
    module.hot.accept("./RecurringRemarkSideMenu.vue?vue&type=template&id=368596d8", function () {
      api.rerender('368596d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recurringremarks/RecurringRemarkSideMenu.vue"
export default component.exports